// extracted by mini-css-extract-plugin
export default {"bg-image":"Modal_bg-image__6m9qy"};